(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cardaga-finish-overlay"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('cardaga-finish-overlay')) return;

  // Resolve computed object-position, including percentages, pixel offsets and
  // the calc(100% - Npx) form browsers use for right/bottom edge offsets.
  function offset(value, space) {
    const keywords = { left: '0%', top: '0%', center: '50%', right: '100%', bottom: '100%' };
    value = keywords[value] || value;
    const expression = value.replace(/^calc\((.*)\)$/, '$1').replace(/\s+/g, '');
    const terms = expression.match(/[+-]?(?:\d*\.)?\d+(?:%|px)?/g);
    if (!terms || terms.join('') !== expression) return NaN;
    return terms.reduce((sum, term) => sum + parseFloat(term) * (term.endsWith('%') ? space / 100 : 1), 0);
  }
  function position(value, xSpace, ySpace) {
    const parts = value.match(/calc\([^)]*\)|[^\s]+/g) || ['50%', '50%'];
    if (parts.length <= 2) {
      if (parts.length === 1) {
        if (parts[0] === 'top' || parts[0] === 'bottom') parts.unshift('50%');
        else parts.push('50%');
      } else if (parts[0] === 'top' || parts[0] === 'bottom') parts.reverse();
      return [offset(parts[0], xSpace), offset(parts[1], ySpace)];
    }
    const result = [xSpace / 2, ySpace / 2];
    for (let i = 0; i < parts.length; i++) {
      const edge = parts[i];
      const axis = ['left', 'right'].includes(edge) ? 0 : ['top', 'bottom'].includes(edge) ? 1 : -1;
      if (axis < 0) return [NaN, NaN];
      const space = axis === 0 ? xSpace : ySpace;
      const distance = i + 1 < parts.length && !/^(left|right|top|bottom|center)$/.test(parts[i + 1]) ? offset(parts[++i], space) : 0;
      result[axis] = ['right', 'bottom'].includes(edge) ? space - distance : distance;
    }
    return result;
  }

  class CardagaFinishOverlay extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.closest('.cardaga-finish-media');
      if (!this.wrapper) return;
      this.images = new Set();
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.wrapper);
      this.mutations = new MutationObserver(records => {
        if (records.some(record => record.target !== this && !this.contains(record.target))) this.schedule();
      });
      this.mutations.observe(this.wrapper, { childList: true, subtree: true, attributes: true,
        attributeFilter: ['src', 'srcset', 'sizes', 'class', 'style', 'hidden', 'data-cardaga-finish-image'] });
      this.wrapper.addEventListener('load', this.schedule, true);
      this.wrapper.addEventListener('error', this.schedule, true);
      this.wrapper.addEventListener('transitionend', this.schedule);
      this.wrapper.addEventListener('pointerenter', this.schedule);
      this.wrapper.addEventListener('pointerleave', this.schedule);
      window.addEventListener('resize', this.schedule);
      this.schedule();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.resize?.disconnect();
      this.mutations?.disconnect();
      if (!this.wrapper) return;
      this.wrapper.removeEventListener('load', this.schedule, true);
      this.wrapper.removeEventListener('error', this.schedule, true);
      this.wrapper.removeEventListener('transitionend', this.schedule);
      this.wrapper.removeEventListener('pointerenter', this.schedule);
      this.wrapper.removeEventListener('pointerleave', this.schedule);
      window.removeEventListener('resize', this.schedule);
    }
    update() {
      const images = [...this.wrapper.querySelectorAll('img')].filter(img => img.closest('.cardaga-finish-media') === this.wrapper);
      for (const img of this.images) if (!images.includes(img)) { this.resize.unobserve(img); this.images.delete(img); }
      for (const img of images) if (!this.images.has(img)) { this.resize.observe(img); this.images.add(img); }
      const marked = images.filter(img => img.hasAttribute('data-cardaga-finish-image'));
      const candidates = (marked.length ? marked : images).filter(img => {
        if (!img.complete || !img.naturalWidth || !img.naturalHeight || !img.getClientRects().length) return false;
        for (let node = img; node; node = node.parentElement) {
          const style = getComputedStyle(node);
          if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) return false;
          if (node === this.wrapper) break;
        }
        return true;
      });
      const img = candidates.sort((a, b) => Number(getComputedStyle(b).opacity) - Number(getComputedStyle(a).opacity))[0];
      const parent = this.offsetParent;
      if (!img || !parent) { this.style.visibility = 'hidden'; return; }
      const style = getComputedStyle(img);
      const px = key => parseFloat(style[key]) || 0;
      const rect = img.getBoundingClientRect();
      const box = parent.getBoundingClientRect();
      const sx = rect.width / img.offsetWidth, sy = rect.height / img.offsetHeight;
      const parentX = box.width / parent.offsetWidth, parentY = box.height / parent.offsetHeight;
      const width = img.clientWidth - px('paddingLeft') - px('paddingRight');
      const height = img.clientHeight - px('paddingTop') - px('paddingBottom');
      let scale = 1, drawnWidth = width, drawnHeight = height;
      if (style.objectFit === 'contain' || style.objectFit === 'cover' || style.objectFit === 'scale-down' || style.objectFit === 'none') {
        scale = style.objectFit === 'cover' ? Math.max(width / img.naturalWidth, height / img.naturalHeight)
          : style.objectFit === 'none' ? 1 : Math.min(width / img.naturalWidth, height / img.naturalHeight);
        if (style.objectFit === 'scale-down') scale = Math.min(1, scale);
        drawnWidth = img.naturalWidth * scale; drawnHeight = img.naturalHeight * scale;
      }
      const [x, y] = position(style.objectPosition || '50% 50%', width - drawnWidth, height - drawnHeight);
      // Replaced content is clipped to the image content box (also handles cover).
      const left = Math.max(0, x), top = Math.max(0, y);
      const visibleWidth = Math.min(width, x + drawnWidth) - left;
      const visibleHeight = Math.min(height, y + drawnHeight) - top;
      const bounds = [
        (rect.left + (px('borderLeftWidth') + px('paddingLeft') + left) * sx - box.left) / parentX - parent.clientLeft + parent.scrollLeft,
        (rect.top + (px('borderTopWidth') + px('paddingTop') + top) * sy - box.top) / parentY - parent.clientTop + parent.scrollTop,
        visibleWidth * sx / parentX, visibleHeight * sy / parentY,
      ];
      if (!bounds.every(Number.isFinite) || bounds[2] <= 0 || bounds[3] <= 0) { this.style.visibility = 'hidden'; return; }
      Object.assign(this.style, { left: bounds[0] + 'px', top: bounds[1] + 'px', width: bounds[2] + 'px', height: bounds[3] + 'px',
        right: 'auto', bottom: 'auto', borderRadius: style.borderRadius, visibility: 'visible' });
    }
  }
  customElements.define('cardaga-finish-overlay', CardagaFinishOverlay);
})();
  } catch(e) { console.error(e); }
})();

})();
